import src from "IMAGE";
export default { src, width: 401, height: 331, blurWidth: 0, blurHeight: 0};
